import { ENV } from "./env";

const serverUrl = ENV.SERVER_URL;

export default serverUrl;
